<loader [loaderText]="store.loaderText"></loader>
<ng-container *ngIf="store.appReadyChanged$ | async">
  <div class="wrapper">
    <toolbar></toolbar>

    <div class="container">
      <ng-container *ngIf="store.hasAccess(); else noAccess">
        <project-selection [disabled]="!(projectSelectionVisible$ | async)" ></project-selection>
        <storage-alert *ngIf="hasOffline$ | async"></storage-alert>
        <router-outlet *ngIf="store.selectedProject"></router-outlet>
        </ng-container>
        <ng-template #noAccess>
          <router-outlet></router-outlet>
        </ng-template>
      </div>
  </div>
</ng-container>


